export enum TdsItem {
  Home,
  Bugly,
  Wuji,
  Kuikly,
  Hippy,
  Shiply,
  Rightly,
  Fue,
  Raft,
  Mmkv,
  Wujie,
  WCDB,
  More,
}
export enum Env {
  TEST,
  PROD,
}

export enum Version {
  WOA,
  PRO,
}
